import { render, staticRenderFns } from "./certificateVerification.vue?vue&type=template&id=27a1ca4c&scoped=true"
import script from "./certificateVerification.vue?vue&type=script&lang=js"
export * from "./certificateVerification.vue?vue&type=script&lang=js"
import style0 from "./certificateVerification.vue?vue&type=style&index=0&id=27a1ca4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1ca4c",
  null
  
)

export default component.exports